export const completeHeaders: string[] = [
  'Material',
  'Formato',
  'Acabamento',
  'Dimensão 1 (mm)',
  'Comprimento (mm)',
  'Qtd. (pç)',
  'Peso (kg)',
  'Custo (R$/kg)',
  'Descrição',
  'Código',
  'Fabricação',
  'Dimensão 2 (mm)',
  'Tratamento Térmico',
  'Densidade (g/cm³)',
  'Custo (R$/mm)',
  'Ncm',
  'Custo total',
  'País de origem',
  'Rua',
  'Prateleira',
  'Localização',
  'Certificados',
  'Notas fiscais',
  'Saldo Disponível',
  'CMC Total',
  'Número de Rastreamento',
  'Família',
  'Situação',
  'Característica',
  'Data de Recebimento',
  'Ordem de Compra',
  'Nº NF',
  'Número do Certificado',
  'Número da Corrida',
]

export const completeFields: string[] = [
  'material',
  'format',
  'finishing',
  'dimension1',
  'lengthInMm',
  'quantity',
  'totalWeight',
  'costPerKg',
  'description',
  'code',
  'fabrication',
  'dimension2',
  'heatTreatment',
  'density',
  'costPerMm',
  'ncm',
  'totalCost',
  'originCountry',
  'stockStreet',
  'shelf',
  'stockLocation',
  'certificates',
  'invoice',
  'availableBalance',
  'totalCmc',
  'trackingNumber',
  'family',
  'stockStatus',
  'characteristic',
  'receivedDate',
  'purchaseOrder',
  'nf',
  'certificateNumber',
]

export interface StockInterface {
  material: string
  density: string
  format: string
  finishing: string
  fabrication: string
  heatTreatment: string
  originCountry: string
  supplier: string
  stockStreet: string
  shelf: string
  stockLocation: string
  quantity: string
  totalWeight: string
  dimension1: string
  dimension2: string
  lengthInMm: string
  costPerKg: string
  costPerMm: string
  totalCost: string
  code: string
  ncm: string
  receivedDate: string
  heatNumber:string
  totalCmc: string
  trackingNumber: string
  family: string
  description: string
  stockStatus: string
  characteristic: string
  purchaseOrder: string
  measurementUnit: string
  availableBalance: string
  nf: string
  certificateNumber: string
}

export const shortHeaders: string[] = [
  'Material',
  'Formato',
  'Acabamento',
  'Dimensão 1 (mm)',
  'Comprimento (mm)',
  'Qtd. (pç)',
  'Peso (kg)',
  'Custo (R$/kg)',
  'Descrição',
  ''
]

export const shortFields: string[] = [
  'material',
  'format',
  'finishing',
  'dimension1',
  'lengthInMm',
  'quantity',
  'totalWeight',
  'costPerKg',
  'description',
]

export const headersToFields = {
  //Tabela de estoque
  Material: 'material',
  Formato: 'format',
  Acabamento: 'finishing',
  Fabricação: 'fabrication',
  'Dimensão 1': 'dimension1',
  Comprimento: 'lengthInMm',
  'Qtd. (pç)': 'quantity',
  Peso: 'totalWeight',
  'Custo/Kg': 'costPerKg',
  Código: 'code',
  'Dimensão 2': 'dimension2',
  'Tratamento Térmico': 'heatTreatment',
  Densidade: 'density',
  'Custo/mm': 'costPerMm',
  Ncm: 'ncm',
  'Custo total': 'totalCost',
  'País de origem': 'originCountry',
  Rua: 'stockStreet',
  Prateleira: 'shelf',
  Localização: 'stockLocation',
  Certificados: 'certificates',
  'Notas fiscais': 'invoice',
  'Saldo Disponível': 'availableBalance',
  'CMC Total': 'totalCmc',
  'Número de Rastreamento': 'trackingNumber',
  Família: 'family',
  Descrição: 'description',
  Situação: 'stockStatus',
  Característica: 'characteristic',
  'Data de Recebimento': 'receivedDate',
  'Ordem de Compra': 'purchaseOrder',
  'Nº NF': 'nf',
  'Número do Certificado': 'certificateNumber',
  'Número da Corrida': 'heatNumber',
  Fornecedor: 'supplier',
  Unidade: 'measurementUnit',
  //Tabela de movimentos
  Pedido: 'ploomesOrderId',
  'Matéria prima': 'rawMaterialName',
  'Tipo do movimento': 'status',
  Quantidade: 'quantity',
  'Peso anterior': 'oldTotalWeight',
  'Peso novo': 'newTotalWeight',
  'Comp. anterior': 'oldLengthInMm',
  'Comp. novo': 'newLengthInMm',
  Data: 'updatedAt',
}

export const fieldsToHeaders = {
  //Tabela de estoque
  material: 'Material',
  format: 'Formato',
  finishing: 'Acabamento',
  fabrication: 'Fabricação',
  dimension1: 'Dimensão 1',
  lengthInMm: 'Comprimento',
  quantity: 'Qtd. (pç)',
  totalWeight: 'Peso',
  costPerKg: 'Custo/Kg',
  code: 'Código',
  dimension2: 'Dimensão 2',
  heatTreatment: 'Tratamento Térmico',
  density: 'Densidade',
  costPerMm: 'Custo/mm',
  ncm: 'Ncm',
  totalCost: 'Custo total',
  originCountry: 'País de origem',
  stockStreet: 'Rua',
  shelf: 'Prateleira',
  stockLocation: 'Localização',
  certificates: 'Certificados',
  invoice: 'Notas fiscais',
  availableBalance: 'Saldo Disponível',
  totalCmc: 'CMC Total',
  trackingNumber: 'Número de Rastreamento',
  family: 'Família',
  description: 'Descrição',
  stockStatus: 'Situação',
  characteristic: 'Característica',
  receivedDate: 'Data de Recebimento',
  purchaseOrder: 'Ordem de Compra',
  nf: 'NF',
  certificateNumber: 'Número do Certificado',
  heatNumber: 'Número da Corrida',
  supplier: 'Fornecedor',
  measurementUnit: 'Unidade',
  //Tabela de movimentos.
  ploomesOrderId: 'Pedido',
  rawMaterialName: 'Matéria prima',
  status: 'Tipo do movimento',
  oldTotalWeight: 'Peso anterior',
  newTotalWeight: 'Peso novo',
  oldLengthInMm: 'Comp. anterior',
  newLengthInMm: 'Comp. novo',
  updatedAt: 'Data',
}

export interface FieldsToHeaders {
  material: string
  format: string
  finishing: string
  fabrication: string
  dimension1: string
  lengthInMm: string
  quantity: string
  totalWeight: string
  costPerKg: string
  code: string
  dimension2: string
  heatTreatment: string
  density: string
  costPerMm: string
  ncm: string
  totalCost: string
  originCountry: string
  stockStreet: string
  shelf: string
  stockLocation: string
  certificates: string[]
  invoice: string[]
  availableBalance: string
  totalCmc: string
  trackingNumber: string
  family: string
  description: string
  stockStatus: string
  characteristic: string
  receivedDate: string
  purchaseOrder: string
  nf: string
  certificateNumber: string
  heatNumber: string
  supplier: string
  ploomesOrderId: string
  rawMaterialName: string
  status: string
  oldTotalWeight: string
  newTotalWeight: string
  oldLengthInMm: string
  newLengthInMm: string
  updatedAt: string
}
